import { createSlice } from "@reduxjs/toolkit";
import {
  getUserClients,
  getClientPrograms,
  getClientSalesRep,
  getBranchesDepartments,
  getLastUpdated,
  getGrowthScore,
  getNpsScore,
  getRetentionLeads,
  getEmailReports,
  getGrowthRate,
  getGrowthRateBenchmark,
  getForecastDetail,
  getAtriskDetail,
  getNetPromoter,
  getCustomerSurvey,
  getRetentionRate,
  getLastPurchaseCustomerLeads,
  getLastPurchaseDetail,
  getProspectLeadsReports,
  getProspectLeadsReportsDetail,
  getGainLostAccounts,
  getIndustryByRevenueDetail,
  getPurchaseDistribution,
  getDistributionTransactionRevenue,
  getCustomerSurveyDetail,
  getProductAnalysisDetail,
  getRankByEmail,
  getRankByStableAccount,
  getRankByWgsDetails,
  getMarketByCustomer,
  getMarketOverview,
  getProductByCustomerCount,
  getProductByRevenue,
  getForecastRevenuePlan,
  getBranchTransaction,
  getTrainingCourse,
  getTrainingModuleSummary,
  getTrainingModule,
  getGrowthRateDetail,
  getClientSalesmenMetrics,
  getRankByRetention,
  getBranchRankByStable,
  getBranchRankByEmail,
  getBranchRankByRetention,
  getAssociatedProduct,
  getTrainingUsers,
  getTrainingRoles,
  getTrainingSchools,
  getTrainingDomains,
  getTableSettings,
  saveTableSettings,
  deleteTableSettings
} from "../../thunks/portalManagementThunk";
import { SelectInfo } from "../../../types/formTypes";
import { PURGE } from "redux-persist";

interface PortalManagementState {
  portalLoading: Boolean;
  portalError: any;
  lastUpdateLoading: Boolean;
  lastUpdateError: any;
  dashboardLoading: Boolean;
  dashboardError: any;
  transactionsLoading: Boolean;
  transactionsError: any;
  salesMarketingLoading: Boolean;
  salesMarketingError: any;
  forecastLoading: Boolean;
  forecastError: any;
  transactionLoading: Boolean;
  transactionError: any;
  revenueLoading: Boolean;
  revenueError: any;
  growthScoreLoading: Boolean;
  growthScoreError: any;
  atRiskLoading: Boolean;
  atRiskError: any;
  npsScoreLoading: Boolean;
  npsScoreError: any;
  retentionLoading: Boolean;
  retentionError: any;
  lastPurchaseCustomerLeadsLoading: Boolean;
  lastPurchaseCustomerLeadsError: any;
  emailReportsLoading: Boolean;
  emailReportsError: any;
  growthRateLoading: Boolean;
  growthRateError: any;
  benchMarkLoading: Boolean;
  benchMarkError: any;
  netPromoterLoading: Boolean;
  netPromoterError: any;
  customerSurveyLoading: Boolean;
  customerSurveyError: any;
  customerSurveyDetailLoading: Boolean;
  customerSurveyDetailError: any;
  retentionRateLoading: Boolean;
  retentionRateError: any;
  industryByRevenueLoading: Boolean;
  industryByRevenueError: any;
  purchaseDistributionLoading: Boolean;
  purchaseDistributionError: any;
  branchTransactionLoading: Boolean;
  branchTransactionError: any;
  distributionTransactionRevenueLoading: Boolean;
  distributionTransactionRevenueError: any;
  forecastRevenuePlanLoading: Boolean;
  forecastRevenuePlanError: any;
  prospectLeadsReportsLoading: Boolean;
  prospectLeadsReportsError: any;
  prospectLeadsReportsDetailLoading: Boolean;
  prospectLeadsReportsDetailError: any;
  gainLostAccountsLoading: Boolean;
  gainLostAccountsError: any;
  marketByCustomerLoading: Boolean;
  marketByCustomerError: any;
  getMarketOverviewLoading: Boolean;
  getMarketOverviewError: any;
  productByRevenueLoading: Boolean;
  productByRevenueError: any;
  productByCustomerCountLoading: Boolean;
  productByCustomerCountError: any;
  rankByStableAccountLoading: Boolean;
  rankByStableAccountError: any;
  rankByEmailLoading: Boolean;
  rankByEmailError: any;
  trainingCourseLoading: Boolean;
  trainingCourseError: any;
  trainingModuleSummaryLoading: Boolean;
  trainingModuleSummaryError: any;
  trainingModuleLoading: Boolean;
  trainingModuleError: any;
  rankByWgsDetailsLoading: Boolean;
  rankByWgsDetailsError: any;
  productAnalysisLoading: Boolean;
  productAnalysisError: any;
  getGrowthRateDetailLoading: Boolean;
  getGrowthRateDetailError: any;
  clientSalesmenMetricsLoading: Boolean;
  clientSalesmenMetricsError: any;
  rankByRetentionLoading: Boolean;
  rankByRetentionError: any;
  branchRankByStableLoading: Boolean;
  branchRankByStableError: any;
  branchRankByEmailLoading: Boolean;
  branchRankByEmailError: any;
  branchRankByRetentionLoading: Boolean;
  branchRankByRetentionError: any;
  getBranchesDepartmentsLoading: Boolean;
  getBranchesDepartmentsError: any;
  getClientUserTitleLoading: Boolean;
  getClientUserTitleError: any;
  getAssociatedProductLoading: Boolean;
  getAssociatedProductError: any;
  error: any;
  response: any;
  success: Boolean;
  portalView: Boolean;
  /**
   * Set only when the user CONFIRMS a context. The live selectedClient /
   * selectedProgram are a work-in-progress while the chooser is open, so they
   * cannot answer "is a dashboard chosen" — the legacy form writes each pick
   * straight to the store, which used to drop you onto the dashboard the moment
   * you picked a program.
   */
  contextCommitted: Boolean;
  /** Most-recently-opened contexts, newest first. See RecentContext. */
  recentContexts: any[];
  /** Context to open on sign-in instead of the chooser. */
  defaultContext: any;
  filteredUserTypes: Object[];
  clients: Object[];
  clientsLoading: boolean;
  clientsError: any;
  programs: Object[];
  programsLoading: boolean;
  programsError: any;
  userTypes: Object[];
  salesReps: Object[];
  salesRepsLoading: boolean;
  salesRepsError: any;
  trainingUsers: Object[];
  trainingUsersLoading: boolean;
  trainingUsersError: any;
  trainingSchools: Object[];
  trainingSchoolsLoading: boolean;
  trainingSchoolsError: any;
  trainingRoles: Object[];
  trainingRolesLoading: boolean;
  trainingRolesError: any;
  trainingDomains: Object[];
  trainingDomainsLoading: boolean;
  trainingDomainsError: any;
  // Per-user persisted table settings, keyed by `${program_index}/${target_table}`.
  // null = fetched but nothing saved; absent key = not fetched yet.
  tableSettings: Record<string, any>;
  tableSettingsLoading: boolean;
  tableSettingsError: any;
  selectedClient: any;
  selectedLastUpdated: any;
  selectedProgram: any;
  selectedUserType: any;
  selectedSalesRep: any;
  selectedSchoolDealer: any;
  selectedBranch: SelectInfo;
  selectedDepartment: SelectInfo;
  branches: string[];
  departments: string[];
  forecastData?: any;
  revinvData?: any;
  allRevinvData?: any;
  purchaseTagRawData?: any;
  purchaseFreqRawData?: any;
  wsrData?: any;
  atRiskData?: any;
  // saleLeadRawData?: any;
  leadRawData?: any;
  lostRawData?: any;
  gainRawData?: any;
  benchRawData?: any;
  sseRawData?: any;
  sseSumRawData?: any;
  dealerRawData?: any;
  benchWSGRawData?: any;
  benchBranches?: string[];
  wsr12RawData?: any;
  wsr36RawData?: any;
  surveyRawData?: any;
  branchTransactionsRawData?: any;
  productDistributionRawData?: any;
  industryRawData?: any;
  industryAllRawData?: any;
  balanceRawData?: any;
  verifiedSunRawData?: any;
  formFillSumRawData?: any;
  gainLost6RawData?: any;
  gainLost12RawData?: any;
  gainLost36RawData?: any;
  marketCustRawData?: any;
  marketCustAllRawData?: any;
  prcustRawData?: any;
  prrevRawData?: any;
  salstbRawData?: any;
  salemRawData?: any;
  trainingCourseRawData?: any;
  studentGradeItemsRawData?: any;
  trainingModuleSummaryRawData?: any;
  trainingModuleRawData?: any;
  rankByWgsDetailsRawData?: any;
  prospectleadDetailRawData?: any;
  prRawData?: any;
  ruleRawData?: any;
  cassRawData?: any;
  clientSalesmenData?: any;
  rankByRetentionData?: any;
  branchRankByStableData?: any;
  branchRankByEmailData?: any;
  branchRankByRetentionData?: any;
  associatedProductData?: any;
}

/** How many contexts the switcher remembers. */
const RECENT_CONTEXT_LIMIT = 6;

const initialState: PortalManagementState = {
  portalLoading: false,
  portalError: null,
  lastUpdateLoading: false,
  lastUpdateError: null,
  dashboardLoading: false,
  dashboardError: null,
  transactionsLoading: false,
  transactionsError: null,
  salesMarketingLoading: false,
  salesMarketingError: null,

  forecastLoading: false,
  forecastError: null,
  transactionLoading: false,
  transactionError: null,
  revenueLoading: false,
  revenueError: null,
  growthScoreLoading: false,
  growthScoreError: null,
  atRiskLoading: false,
  atRiskError: null,
  npsScoreLoading: false,
  npsScoreError: null,
  retentionLoading: false,
  retentionError: null,
  lastPurchaseCustomerLeadsLoading: false,
  lastPurchaseCustomerLeadsError: null,
  emailReportsLoading: false,
  emailReportsError: null,
  growthRateLoading: false,
  growthRateError: null,
  benchMarkLoading: false,
  benchMarkError: null,
  netPromoterLoading: false,
  netPromoterError: null,
  customerSurveyLoading: false,
  customerSurveyError: null,
  customerSurveyDetailLoading: false,
  customerSurveyDetailError: null,
  retentionRateLoading: false,
  retentionRateError: null,
  industryByRevenueLoading: false,
  industryByRevenueError: null,
  purchaseDistributionLoading: false,
  purchaseDistributionError: null,
  branchTransactionLoading: false,
  branchTransactionError: null,
  distributionTransactionRevenueLoading: false,
  distributionTransactionRevenueError: null,
  forecastRevenuePlanLoading: false,
  forecastRevenuePlanError: null,
  prospectLeadsReportsLoading: false,
  prospectLeadsReportsError: null,
  prospectLeadsReportsDetailLoading: false,
  prospectLeadsReportsDetailError: null,
  gainLostAccountsLoading: false,
  gainLostAccountsError: null,
  marketByCustomerLoading: false,
  marketByCustomerError: null,
  getMarketOverviewLoading: false,
  getMarketOverviewError: null,
  productByRevenueLoading: false,
  productByRevenueError: null,
  productByCustomerCountLoading: false,
  productByCustomerCountError: null,
  rankByStableAccountLoading: false,
  rankByStableAccountError: null,
  rankByEmailLoading: false,
  rankByEmailError: null,
  trainingCourseLoading: false,
  trainingCourseError: null,
  trainingModuleSummaryLoading: false,
  trainingModuleSummaryError: null,
  trainingModuleLoading: false,
  trainingModuleError: null,
  rankByWgsDetailsLoading: false,
  rankByWgsDetailsError: null,
  productAnalysisLoading: false,
  productAnalysisError: null,
  getGrowthRateDetailLoading: false,
  getGrowthRateDetailError: null,
  clientSalesmenMetricsLoading: false,
  clientSalesmenMetricsError: null,
  rankByRetentionLoading: false,
  rankByRetentionError: null,
  branchRankByStableLoading: false,
  branchRankByStableError: null,
  branchRankByEmailLoading: false,
  branchRankByEmailError: null,
  branchRankByRetentionLoading: false,
  branchRankByRetentionError: null,
  getBranchesDepartmentsLoading: false,
  getBranchesDepartmentsError: null,
  getClientUserTitleLoading: false,
  getClientUserTitleError: null,
  getAssociatedProductLoading: false,
  getAssociatedProductError: null,
  error: null,
  response: null,
  success: false,
  portalView: true,
  contextCommitted: false,
  recentContexts: [],
  defaultContext: null,
  filteredUserTypes: [],
  clients: [],
  clientsLoading: false,
  clientsError: null,
  programsLoading: false,
  programsError: null,
  salesRepsLoading: false,
  salesRepsError: null,
  trainingUsersLoading: false,
  trainingUsersError: null,
  trainingRolesLoading: false,
  trainingRolesError: null,
  trainingSchoolsLoading: false,
  trainingSchoolsError: null,
  trainingDomainsLoading: false,
  trainingDomainsError: null,
  selectedClient: null,
  selectedLastUpdated: null,
  selectedProgram: null,
  selectedUserType: null,
  selectedSalesRep: null,
  selectedSchoolDealer: null,
  programs: [],
  userTypes: [],
  salesReps: [],
  trainingUsers: [],
  trainingRoles: [],
  trainingSchools: [],
  trainingDomains: [],
  tableSettings: {},
  tableSettingsLoading: false,
  tableSettingsError: null,
  selectedBranch: { label: "Overall", value: "Overall" },
  selectedDepartment: { label: "Overall", value: "Overall" },

  branches: [],
  departments: [],
  forecastData: null,
  revinvData: null,
  allRevinvData: null,
  purchaseTagRawData: null,
  purchaseFreqRawData: null,
  wsrData: null,
  atRiskData: null,
  // saleLeadRawData: null,
  leadRawData: null,
  lostRawData: null,
  gainRawData: null,
  benchRawData: null,
  sseRawData: null,
  sseSumRawData: null,
  dealerRawData: null,
  benchWSGRawData: null,
  benchBranches: [],
  wsr12RawData: null,
  wsr36RawData: null,
  surveyRawData: null,
  branchTransactionsRawData: null,
  productDistributionRawData: null,
  industryRawData: null,
  industryAllRawData: null,
  balanceRawData: null,
  verifiedSunRawData: null,
  formFillSumRawData: null,
  gainLost6RawData: null,
  gainLost12RawData: null,
  gainLost36RawData: null,
  marketCustRawData: null,
  marketCustAllRawData: null,
  prcustRawData: null,
  prrevRawData: null,
  salstbRawData: null,
  salemRawData: null,
  trainingCourseRawData: null,
  studentGradeItemsRawData: null,
  trainingModuleSummaryRawData: null,
  trainingModuleRawData: null,
  rankByWgsDetailsRawData: null,
  prospectleadDetailRawData: null,
  rankByRetentionData: null,
  prRawData: null,
  ruleRawData: null,
  cassRawData: null,
  clientSalesmenData: null,
  branchRankByStableData: null,
  branchRankByEmailData: null,
  branchRankByRetentionData: null,
  associatedProductData: null,
};

export const PortalManagementSlice = createSlice({
  name: "portalManagement",
  initialState,
  reducers: {
    portalManagementReset: (state) => {
      state.contextCommitted = false;

      state.filteredUserTypes = [];
      state.programs = [];
      state.clients = [];
      state.userTypes = [];
      state.salesReps = [];
      state.trainingUsers = [];
      state.trainingSchools = [];
      state.trainingDomains = [];
      state.trainingRoles = [];
      state.tableSettings = {};

      state.selectedClient = null;
      state.selectedLastUpdated = null;
      state.selectedProgram = null;
      state.selectedUserType = null;
      state.selectedSalesRep = null;
      state.selectedSchoolDealer = null;
      
      state.selectedBranch = { label: "Overall", value: "Overall" };
      state.selectedDepartment = { label: "Overall", value: "Overall" };

      state.forecastData = null;
      state.revinvData = null;
      state.allRevinvData = null;
      state.allRevinvData = null;
      state.purchaseTagRawData = null;
      state.purchaseFreqRawData = null;
      state.wsrData = null;
      state.atRiskData = null;
      // state.saleLeadRawData = null;
      state.leadRawData = null;
      state.lostRawData = null;
      state.gainRawData = null;
      state.benchRawData = null;
      state.sseRawData = null;
      state.sseSumRawData = null;
      state.dealerRawData = null;
      state.benchWSGRawData = null;
      state.benchBranches = [];
      state.wsr12RawData = null;
      state.wsr36RawData = null;
      state.surveyRawData = null;
      state.branchTransactionsRawData = null;
      state.productDistributionRawData = null;
      state.rankByRetentionData = null;
      state.clientsLoading = false;
      state.programsLoading = false;
      state.salesRepsLoading = false;
      state.trainingUsersLoading = false;
      state.trainingRolesLoading = false;
      state.trainingSchoolsLoading = false;
      state.trainingDomainsLoading = false;

      state.dashboardLoading = false;
      state.transactionsLoading = false;
      state.salesMarketingLoading = false;

      state.industryRawData = null;
      state.industryAllRawData = null;
      state.balanceRawData = null;
      state.verifiedSunRawData = null;
      state.formFillSumRawData = null;
      state.gainLost6RawData = null;
      state.gainLost12RawData = null;
      state.gainLost36RawData = null;
      state.marketCustRawData = null;
      state.marketCustAllRawData = null;
      state.prcustRawData = null;
      state.prrevRawData = null;
      state.salstbRawData = null;
      state.salemRawData = null;
      state.salstbRawData = null;
      state.trainingCourseRawData = null;
      state.studentGradeItemsRawData = null;
      state.trainingModuleSummaryRawData = null;
      state.trainingModuleRawData = null;
      state.rankByWgsDetailsRawData = null;
      state.prospectleadDetailRawData = null;
      state.prRawData = null;
      state.ruleRawData = null;
      state.cassRawData = null;
      state.clientSalesmenData = null;
      state.branchRankByStableData = null;
      state.branchRankByEmailData = null;
      state.branchRankByRetentionData = null;
      state.associatedProductData = null;
      state.forecastLoading = false;
      state.transactionLoading = false;
      state.revenueLoading = false;
      state.growthScoreLoading = false;
      state.atRiskLoading = false;
      state.npsScoreLoading = false;
      state.retentionLoading = false;
      state.lastPurchaseCustomerLeadsLoading = false;
      state.emailReportsLoading = false;
      state.growthRateLoading = false;
      state.benchMarkLoading = false;
      state.netPromoterLoading = false;
      state.customerSurveyLoading = false;
      state.customerSurveyDetailLoading = false;
      state.retentionRateLoading = false;
      state.industryByRevenueLoading = false;
      state.purchaseDistributionLoading = false;
      state.branchTransactionLoading = false;
      state.distributionTransactionRevenueLoading = false;
      state.forecastRevenuePlanLoading = false;
      state.prospectLeadsReportsLoading = false;
      state.prospectLeadsReportsDetailLoading = false;
      state.gainLostAccountsLoading = false;
      state.marketByCustomerLoading = false;
      state.getMarketOverviewLoading = false;
      state.productByRevenueLoading = false;
      state.productByCustomerCountLoading = false;
      state.rankByStableAccountLoading = false;
      state.rankByEmailLoading = false;
      state.trainingCourseLoading = false;
      state.trainingModuleSummaryLoading = false;
      state.trainingModuleLoading = false;
      state.rankByWgsDetailsLoading = false;
      state.productAnalysisLoading = false;
      state.getGrowthRateDetailLoading = false;
      state.lastUpdateLoading = false;
      state.clientSalesmenMetricsLoading = false;
      state.rankByRetentionLoading = false;
      state.branchRankByStableLoading = false;
      state.branchRankByEmailLoading = false;
      state.branchRankByRetentionLoading = false;
      state.getBranchesDepartmentsLoading = false;
      state.getClientUserTitleLoading = false;
      state.getAssociatedProductLoading = false;
    },
    /**
     * Wipe analytics payloads for a context switch. Does not touch
     * selectedClient — the wave session keys on customer_id, so re-applying
     * the already-active context must skip this wipe (empty tiles + skipped
     * refetch). analyticsView resets the session when selectedClient identity
     * changes.
     */
    portalManagementSearchReset: (state) => {
      state.selectedBranch = { label: "Overall", value: "Overall" };
      state.selectedDepartment = { label: "Overall", value: "Overall" };

      state.clientsLoading = false;
      state.programsLoading = false;
      state.salesRepsLoading = false;
      state.trainingUsersLoading = false;
      state.trainingRolesLoading = false;
      state.trainingSchoolsLoading = false;
      state.trainingDomainsLoading = false;
      state.dashboardLoading = false;
      state.transactionsLoading = false;
      state.salesMarketingLoading = false;
      state.lastUpdateLoading = false;
      state.forecastLoading = false;
      state.growthScoreLoading = false;
      state.atRiskLoading = false;
      state.retentionLoading = false;
      state.emailReportsLoading = false;
      state.growthRateLoading = false;
      state.benchMarkLoading = false;
      state.netPromoterLoading = false;
      state.customerSurveyLoading = false;
      state.customerSurveyDetailLoading = false;
      state.retentionRateLoading = false;
      state.industryByRevenueLoading = false;
      state.purchaseDistributionLoading = false;
      state.branchTransactionLoading = false;
      state.distributionTransactionRevenueLoading = false;
      state.forecastRevenuePlanLoading = false;
      state.prospectLeadsReportsLoading = false;
      state.prospectLeadsReportsDetailLoading = false;
      state.gainLostAccountsLoading = false;
      state.marketByCustomerLoading = false;
      state.getMarketOverviewLoading = false;
      state.productByRevenueLoading = false;
      state.productByCustomerCountLoading = false;
      state.rankByStableAccountLoading = false;
      state.rankByEmailLoading = false;
      state.trainingCourseLoading = false;
      state.trainingModuleSummaryLoading = false;
      state.trainingModuleLoading = false;
      state.rankByWgsDetailsLoading = false;
      state.productAnalysisLoading = false;
      state.getGrowthRateDetailLoading = false;
      state.clientSalesmenMetricsLoading = false;
      state.rankByRetentionLoading = false;
      state.branchRankByStableLoading = false;
      state.branchRankByEmailLoading = false;
      state.branchRankByRetentionLoading = false;
      state.getBranchesDepartmentsLoading = false;
      state.getClientUserTitleLoading = false;
      state.getAssociatedProductLoading = false;
      state.forecastData = null;
      state.revinvData = null;
      state.allRevinvData = null;
      state.purchaseTagRawData = null;
      state.purchaseFreqRawData = null;
      state.wsrData = null;
      state.atRiskData = null;
      // state.saleLeadRawData = null;
      state.leadRawData = null;
      state.lostRawData = null;
      state.gainRawData = null;
      state.benchRawData = null;
      state.sseRawData = null;
      state.sseSumRawData = null;
      state.dealerRawData = null;
      state.benchWSGRawData = null;
      state.benchBranches = [];
      state.wsr12RawData = null;
      state.wsr36RawData = null;
      state.surveyRawData = null;
      state.branchTransactionsRawData = null;
      state.productDistributionRawData = null;
      state.industryRawData = null;
      state.industryAllRawData = null;
      state.balanceRawData = null;
      state.verifiedSunRawData = null;
      state.formFillSumRawData = null;
      state.gainLost6RawData = null;
      state.gainLost12RawData = null;
      state.gainLost36RawData = null;
      state.marketCustRawData = null;
      state.marketCustAllRawData = null;
      state.prcustRawData = null;
      state.prrevRawData = null;
      state.salstbRawData = null;
      state.salemRawData = null;
      state.trainingCourseRawData = null;
      state.studentGradeItemsRawData = null;
      state.trainingModuleSummaryRawData = null;
      state.trainingModuleRawData = null;
      state.rankByWgsDetailsRawData = null;
      state.prospectleadDetailRawData = null;
      state.clientSalesmenData = null;
      state.rankByRetentionData = null;
      state.branchRankByStableData = null;
      state.branchRankByEmailData = null;
      state.branchRankByRetentionData = null;
      state.associatedProductData = null;
    },
    /**
     * Remember a context the user just opened, newest first.
     *
     * Self-heals `recentContexts` first: redux-persist uses autoMergeLevel1,
     * which restores this slice wholesale and does NOT merge initialState in.
     * Every browser holding a snapshot from before this field existed would
     * otherwise hit `undefined.filter` on the first dispatch.
     *
     * Not cleared by portalManagementReset on purpose — that also runs when
     * System Management mounts, which would wipe the list mid-session. Logout
     * calls persistor.purge(), which is what actually clears it.
     */
    recordRecentContext: (state, action) => {
      if (!Array.isArray(state.recentContexts)) state.recentContexts = [];
      const context = action.payload;
      if (!context?.id) return;
      state.recentContexts = [
        context,
        ...state.recentContexts.filter((c: any) => c?.id !== context.id),
      ].slice(0, RECENT_CONTEXT_LIMIT);
    },
    setContextCommitted: (state, action) => {
      state.contextCommitted = Boolean(action.payload);
    },
    setDefaultContext: (state, action) => {
      state.defaultContext = action.payload ?? null;
    },
    updatePortalView: (state) => {
      state.portalView = !state.portalView;
    },
    setFilteredUserTypes: (state, action) => {
      state.filteredUserTypes = action.payload;
    },
    setSelectedClient: (state, action) => {
      state.selectedClient = action.payload;
      state.programs = [];
      state.filteredUserTypes = [];
      state.salesReps = [];
      state.trainingUsers = [];
      state.trainingRoles = [];
      state.trainingSchools = [];
      state.trainingDomains = [];
      state.selectedProgram = null;
      state.selectedUserType = null;
      state.selectedSalesRep = null;
      state.selectedSchoolDealer = null;
    },
    setSelectedClientOther: (state, action) => {
      state.selectedClient = action.payload;
    },
    setSelectedProgram: (state, action) => {
      state.selectedProgram = action.payload;
      state.filteredUserTypes = [];
      state.salesReps = [];
      state.trainingUsers = [];
      state.trainingSchools = [];
      state.trainingRoles = [];
      state.trainingDomains = [];
      state.selectedUserType = null;
      state.selectedSalesRep = null;
      state.selectedSchoolDealer = null;
    },
    setSelectedUserType: (state, action) => {
      state.selectedUserType = action.payload;
      state.salesReps = [];
      state.trainingUsers = [];
      state.trainingSchools = [];
      state.trainingRoles = [];
      state.trainingDomains = [];
      state.selectedSalesRep = null;
      state.selectedSchoolDealer = null;
    },
    setSelectedSalesRep: (state, action) => {
      state.selectedSalesRep = action.payload;
    },
    setSelectedSchoolDealer: (state, action) => {
      state.selectedSchoolDealer = action.payload;
    },
    setSelectedBranch: (state, action) => {
      state.selectedBranch = action.payload
        ? action.payload
        : { label: "Overall", value: "Overall" };
    },
    setSelectedDepartment: (state, action) => {
      state.selectedDepartment = action.payload
        ? action.payload
        : { label: "Overall", value: "Overall" };
    },
  },
  extraReducers(builder) {
    builder.addCase(PURGE, () => { return initialState; });
    // Clients Info
    builder.addCase(getUserClients.pending, (state) => {
      state.clientsLoading = true;
      state.clientsError = null;
      state.error = null;
    });
    builder.addCase(getUserClients.fulfilled, (state, action) => {
      state.clientsLoading = false;
      state.userTypes = action.payload.user_types;
      state.clients = action.payload.user_clients;
    });
    builder.addCase(getUserClients.rejected, (state, action) => {
      state.clientsLoading = false;
      state.clientsError = action.payload;
      state.error = action.payload;
    });

    // Clients Programs
    builder.addCase(getClientPrograms.pending, (state) => {
      state.programsLoading = true;
      state.programsError = null;
      state.error = null;
    });
    builder.addCase(getClientPrograms.fulfilled, (state, action) => {
      state.programsLoading = false;
      // Program 103 (Equipment Analytics) retired 2026-08-08 — the DB still
      // grants it to two clients until a migration removes the rows; filtered
      // here so no chooser can offer a program with no view behind it.
      state.programs = (action.payload.programs ?? []).filter(
        (p: any) => p.program_index !== 103
      );
    });
    builder.addCase(getClientPrograms.rejected, (state, action) => {
      state.programsLoading = false;
      state.programsError = action.payload;
      state.error = action.payload;
    });

    // Clients Sales Rep
    builder.addCase(getClientSalesRep.pending, (state) => {
      state.salesRepsLoading = true;
      state.salesRepsError = null;
      state.error = null;
    });
    builder.addCase(getClientSalesRep.fulfilled, (state, action) => {
      state.salesRepsLoading = false;
      state.salesReps = action.payload.salesmen_list.sort(
        (a: any, b: any) => {
          if (a.SALESMAN < b.SALESMAN) {
            return -1;
          }
        }
      );
    });
    builder.addCase(getClientSalesRep.rejected, (state, action) => {
      state.salesRepsLoading = false;
      state.salesRepsError = action.payload;
      state.error = action.payload;
    });

    // Training Users 
    builder.addCase(getTrainingUsers.pending, (state) => {
      state.trainingUsersLoading = true;
      state.trainingUsersError = null;
      state.error = null;
    });
    builder.addCase(getTrainingUsers.fulfilled, (state, action) => {
      state.trainingUsersLoading = false;
      state.trainingUsers = action.payload.training_users
    });
    builder.addCase(getTrainingUsers.rejected, (state, action) => {
      state.trainingUsersLoading = false;
      state.trainingUsersError = action.payload;
      state.error = action.payload;
    });

    // Training Roles 
    builder.addCase(getTrainingRoles.pending, (state) => {
      state.trainingRolesLoading = true;
      state.trainingRolesError = null;
      state.error = null;
    });
    builder.addCase(getTrainingRoles.fulfilled, (state, action) => {
      state.trainingRolesLoading = false;
      state.trainingRoles = action.payload.training_roles
    });
    builder.addCase(getTrainingRoles.rejected, (state, action) => {
      state.trainingRolesLoading = false;
      state.trainingRolesError = action.payload;
      state.error = action.payload;
    });

    // Training Schools 
    builder.addCase(getTrainingSchools.pending, (state) => {
      state.trainingSchoolsLoading = true;
      state.trainingSchoolsError = null;
      state.error = null;
    });
    builder.addCase(getTrainingSchools.fulfilled, (state, action) => {
      state.trainingSchoolsLoading = false;
      state.trainingSchools = action.payload.training_schools
    });
    builder.addCase(getTrainingSchools.rejected, (state, action) => {
      state.trainingSchoolsLoading = false;
      state.trainingSchoolsError = action.payload;
      state.error = action.payload;
    });

    // Training Domains 
    builder.addCase(getTrainingDomains.pending, (state) => {
      state.trainingDomainsLoading = true;
      state.trainingDomainsError = null;
      state.error = null;
    });
    builder.addCase(getTrainingDomains.fulfilled, (state, action) => {
      state.trainingDomainsLoading = false;
      state.trainingDomains = action.payload.training_domains
    });
    builder.addCase(getTrainingDomains.rejected, (state, action) => {
      state.trainingDomainsLoading = false;
      state.trainingDomainsError = action.payload;
      state.error = action.payload;
    });

    // Per-user table settings
    builder.addCase(getTableSettings.pending, (state) => {
      state.tableSettingsLoading = true;
      state.tableSettingsError = null;
      state.error = null;
    });
    builder.addCase(getTableSettings.fulfilled, (state, action) => {
      state.tableSettingsLoading = false;
      // Rehydrated pre-existing persisted state may lack this field
      if (!state.tableSettings) state.tableSettings = {};
      state.tableSettings[`${action.payload.program_index}/${action.payload.target_table}`] =
        action.payload.settings;
    });
    builder.addCase(getTableSettings.rejected, (state, action) => {
      state.tableSettingsLoading = false;
      state.tableSettingsError = action.payload;
      state.error = action.payload;
    });
    builder.addCase(saveTableSettings.fulfilled, (state, action) => {
      if (!state.tableSettings) state.tableSettings = {};
      state.tableSettings[`${action.payload.program_index}/${action.payload.target_table}`] =
        action.payload.settings;
    });
    builder.addCase(saveTableSettings.rejected, (state, action) => {
      state.error = action.payload;
    });
    builder.addCase(deleteTableSettings.fulfilled, (state, action) => {
      if (!state.tableSettings) state.tableSettings = {};
      state.tableSettings[`${action.payload.program_index}/${action.payload.target_table}`] = null;
    });
    builder.addCase(deleteTableSettings.rejected, (state, action) => {
      state.error = action.payload;
    });

    // Branches and Departments
    builder.addCase(getBranchesDepartments.pending, (state) => {
      state.getBranchesDepartmentsLoading = true;
      state.getBranchesDepartmentsError = null;
      state.error = null;
    });
    builder.addCase(getBranchesDepartments.fulfilled, (state, action) => {
      state.getBranchesDepartmentsLoading = false;
      state.branches = action.payload.all_branch
        .sort()
        .map((branch: string) => {
          return { value: branch, label: branch };
        });
      state.departments = action.payload.all_department
        .sort()
        .map((branch: string) => {
          return { value: branch, label: branch };
        });
    });
    builder.addCase(getBranchesDepartments.rejected, (state, action) => {
      state.getBranchesDepartmentsLoading = false;
      state.getBranchesDepartmentsError = action.payload;
      state.error = action.payload;
    });

    // Last Updated
    builder.addCase(getLastUpdated.pending, (state) => {
      state.lastUpdateLoading = true;
      state.lastUpdateError = null;
      state.error = null;
    });
    builder.addCase(getLastUpdated.fulfilled, (state, action) => {
      state.lastUpdateLoading = false;
      state.selectedLastUpdated = action.payload.last_updated;
    });
    builder.addCase(getLastUpdated.rejected, (state, action) => {
      state.lastUpdateLoading = false;
      state.lastUpdateError = action.payload;
      state.error = action.payload;
    });

    // Forecast Detail
    builder.addCase(getForecastDetail.pending, (state) => {
      state.forecastLoading = true;
      state.forecastError = null;
      state.error = null;
    });
    builder.addCase(getForecastDetail.fulfilled, (state, action) => {
      state.forecastLoading = false;
      state.forecastData = {
        ...state.forecastData,
        ...action.payload.forecast_dic,
      };
      // state.revinvData = { ...state.revinvData, ...action.payload.revinv_data };
    });
    builder.addCase(getForecastDetail.rejected, (state, action) => {
      state.forecastLoading = false;
      state.forecastError = action.payload;
      state.error = action.payload;
    });

    // Growth Score
    builder.addCase(getGrowthScore.pending, (state) => {
      state.growthScoreLoading = true;
      state.growthScoreError = null;
      state.error = null;
    });
    builder.addCase(getGrowthScore.fulfilled, (state, action) => {
      state.growthScoreLoading = false;
      state.salesReps = action.payload;
    });
    builder.addCase(getGrowthScore.rejected, (state, action) => {
      state.growthScoreLoading = false;
      state.growthScoreError = action.payload;
      state.error = action.payload;
    });

    // Atrisk Detail
    builder.addCase(getAtriskDetail.pending, (state) => {
      state.atRiskLoading = true;
      state.atRiskError = null;
      state.error = null;
    });
    builder.addCase(getAtriskDetail.fulfilled, (state, action) => {
      state.atRiskLoading = false;
      state.atRiskData = action.payload.atrisk_data;
    });
    builder.addCase(getAtriskDetail.rejected, (state, action) => {
      state.atRiskLoading = false;
      state.atRiskError = action.payload;
      state.error = action.payload;
    });

    // Nps Score
    builder.addCase(getNpsScore.pending, (state) => {
      state.npsScoreLoading = true;
      state.npsScoreError = null;
      state.error = null;
    });
    builder.addCase(getNpsScore.fulfilled, (state, action) => {
      state.npsScoreLoading = false;
      state.wsr12RawData = {
        ...state.wsr12RawData,
        ...action.payload.wsr_12m_dic,
      };
    });
    builder.addCase(getNpsScore.rejected, (state, action) => {
      state.npsScoreLoading = false;
      state.npsScoreError = action.payload;
      state.error = action.payload;
    });

    // Retention Leads
    builder.addCase(getRetentionLeads.pending, (state) => {
      state.retentionLoading = true;
      state.retentionError = null;
      state.error = null;
    });

    builder.addCase(getRetentionLeads.fulfilled, (state, action) => {
      state.retentionLoading = false;

      state.leadRawData = {
        ...state.leadRawData,
        cust_lead : action.payload.lead_dic?.cust_lead }

      state.lostRawData = {
        ...state.lostRawData,
        cust_lead: action.payload.lost_dic?.cust_lead }

      state.gainRawData = {
        ...state.gainRawData,
        cust_lead: action.payload.gain_dic?.cust_lead }

    });
    
    builder.addCase(getRetentionLeads.rejected, (state, action) => {
      state.retentionLoading = false;
      state.retentionError = action.payload;
      state.error = action.payload;
    });

    // Last Purchase Customer Leads
    builder.addCase(getLastPurchaseCustomerLeads.pending, (state) => {
      state.lastPurchaseCustomerLeadsLoading = true;
      state.lastPurchaseCustomerLeadsError = null;
      state.error = null;
    });
    builder.addCase(getLastPurchaseCustomerLeads.fulfilled, (state, action) => {
      state.lastPurchaseCustomerLeadsLoading = false;
      state.leadRawData = { ...state.leadRawData, ...action.payload.lead_dic };
      state.lostRawData = { ...state.lostRawData, ...action.payload.lost_dic };
      state.gainRawData = { ...state.gainRawData, ...action.payload.gain_dic };
    });
    builder.addCase(getLastPurchaseCustomerLeads.rejected, (state, action) => {
      state.lastPurchaseCustomerLeadsLoading = false;
      state.lastPurchaseCustomerLeadsError = action.payload;
      state.error = action.payload;
    });

    // Last Purchase Detail
    // builder.addCase(getLastPurchaseDetail.pending, (state) => {
    //   state.error = null;
    // });
    // builder.addCase(getLastPurchaseDetail.fulfilled, (state, action) => {
    //   state.saleLeadRawData = action.payload;
    // });
    // builder.addCase(getLastPurchaseDetail.rejected, (state, action) => {
    //   state.error = action.payload;
    // });

    // Email Reports
    builder.addCase(getEmailReports.pending, (state) => {
      state.emailReportsLoading = true;
      state.emailReportsError = null;
      state.error = null;
    });
    builder.addCase(getEmailReports.fulfilled, (state, action) => {
      state.emailReportsLoading = false;
      state.benchRawData = {
        ...state.benchRawData,
        ...action.payload.bench_dic,
      };
      state.sseRawData = action.payload.ss_email_dic;
      state.sseSumRawData = action.payload.ss_email_sum;
    });
    builder.addCase(getEmailReports.rejected, (state, action) => {
      state.emailReportsLoading = false;
      state.emailReportsError = action.payload;
      state.error = action.payload;
    });

    // Growth Rate
    builder.addCase(getGrowthRate.pending, (state) => {
      state.growthRateLoading = true;
      state.growthRateError = null;
      state.error = null;
    });
    builder.addCase(getGrowthRate.fulfilled, (state, action) => {
      state.growthRateLoading = false;
      state.revinvData = { ...state.revinvData, ...action.payload.revinv_data };
    });
    builder.addCase(getGrowthRate.rejected, (state, action) => {
      state.growthRateLoading = false;
      state.growthRateError = action.payload;
      state.error = action.payload;
    });

    // Growth Rate Benchmark
    builder.addCase(getGrowthRateBenchmark.pending, (state) => {
      state.benchMarkLoading = true;
      state.benchMarkError = null;
      state.error = null;
    });
    builder.addCase(getGrowthRateBenchmark.fulfilled, (state, action) => {
      state.benchMarkLoading = false;
      state.benchRawData = {
        ...state.benchRawData,
        ...action.payload.bench_dic,
      };
      state.dealerRawData = action.payload.deal_dic;
      state.benchWSGRawData = action.payload.bench_wgs;
      state.benchBranches = action.payload.all_branch;
    });
    builder.addCase(getGrowthRateBenchmark.rejected, (state, action) => {
      state.benchMarkLoading = false;
      state.benchMarkError = action.payload;
      state.error = action.payload;
    });

    // Net Promoter
    builder.addCase(getNetPromoter.pending, (state) => {
      state.netPromoterLoading = true;
      state.netPromoterError = null;
      state.error = null;
    });
    builder.addCase(getNetPromoter.fulfilled, (state, action) => {
      state.netPromoterLoading = false;
      state.wsr12RawData = {
        ...state.wsr12RawData,
        ...action.payload.wsr_12m_dic,
      };
      state.surveyRawData = action.payload.survey_data;
    });
    builder.addCase(getNetPromoter.rejected, (state, action) => {
      state.netPromoterLoading = false;
      state.netPromoterError = action.payload;
      state.error = action.payload;
    });

    // Customer Survey
    builder.addCase(getCustomerSurvey.pending, (state) => {
      state.customerSurveyLoading = true;
      state.customerSurveyError = null;
      state.error = null;
    });
    builder.addCase(getCustomerSurvey.fulfilled, (state, action) => {
      state.customerSurveyLoading = false;
      state.wsr12RawData = {
        ...state.wsr12RawData,
        ...action.payload.wsr_12m_dic,
      };
    });
    builder.addCase(getCustomerSurvey.rejected, (state, action) => {
      state.customerSurveyLoading = false;
      state.customerSurveyError = action.payload;
      state.error = action.payload;
    });

    // Customer Survey Detail
    builder.addCase(getCustomerSurveyDetail.pending, (state) => {
      state.customerSurveyDetailLoading = false;
      state.customerSurveyDetailError = null;
      state.error = null;
    });
    builder.addCase(getCustomerSurveyDetail.fulfilled, (state, action) => {
      state.customerSurveyDetailLoading = false;
      state.wsr36RawData = action.payload.wsr_36m_dic;
    });
    builder.addCase(getCustomerSurveyDetail.rejected, (state, action) => {
      state.customerSurveyDetailLoading = false;
      state.customerSurveyDetailError = action.payload;
      state.error = action.payload;
    });

    // Retention Rate
    builder.addCase(getRetentionRate.pending, (state) => {
      state.retentionRateLoading = true;
      state.retentionRateError = null;
      state.error = null;
    });
    builder.addCase(getRetentionRate.fulfilled, (state, action) => {
      state.retentionRateLoading = false;
      state.revinvData = { ...state.revinvData, ...action.payload.revinv_data };
    });
    builder.addCase(getRetentionRate.rejected, (state, action) => {
      state.retentionRateLoading = false;
      state.retentionRateError = action.payload;
      state.error = action.payload;
    });

    // Industry By Revenue Detail
    builder.addCase(getIndustryByRevenueDetail.pending, (state) => {
      state.industryByRevenueLoading = true;
      state.industryByRevenueError = null;
      state.error = null;
    });
    builder.addCase(getIndustryByRevenueDetail.fulfilled, (state, action) => {
      state.industryByRevenueLoading = false;
      state.industryRawData = action.payload.industry_distribution;
      state.industryAllRawData = action.payload.industry_all;
    });
    builder.addCase(getIndustryByRevenueDetail.rejected, (state, action) => {
      state.industryByRevenueLoading = false;
      state.industryByRevenueError = action.payload;
      state.error = action.payload;
    });

    // Purchase Distribution
    builder.addCase(getPurchaseDistribution.pending, (state) => {
      state.purchaseDistributionLoading = true;
      state.purchaseDistributionError = null;
      state.error = null;
    });
    builder.addCase(getPurchaseDistribution.fulfilled, (state, action) => {
      state.purchaseDistributionLoading = false;
      state.purchaseTagRawData = action.payload.last_purchase_tag;
      state.purchaseFreqRawData = action.payload.purchase_frequency;
    });
    builder.addCase(getPurchaseDistribution.rejected, (state, action) => {
      state.purchaseDistributionLoading = false;
      state.purchaseDistributionError = action.payload;
      state.error = action.payload;
    });

    // Branch Transaction
    builder.addCase(getBranchTransaction.pending, (state) => {
      state.branchTransactionLoading = true;
      state.branchTransactionError = null;
      state.error = null;
    });
    builder.addCase(getBranchTransaction.fulfilled, (state, action) => {
      state.branchTransactionLoading = false;
      state.branchTransactionsRawData = action.payload.branch_data;
    });
    builder.addCase(getBranchTransaction.rejected, (state, action) => {
      state.branchTransactionLoading = false;
      state.branchTransactionError = action.payload;
      state.error = action.payload;
    });

    // Distribution Transaction Revenue
    builder.addCase(getDistributionTransactionRevenue.pending, (state) => {
      state.distributionTransactionRevenueLoading = true;
      state.distributionTransactionRevenueError = null;
      state.error = null;
    });
    builder.addCase(
      getDistributionTransactionRevenue.fulfilled,
      (state, action) => {
        state.distributionTransactionRevenueLoading = false;
        state.productDistributionRawData = action.payload.product_distribution;
      }
    );
    builder.addCase(
      getDistributionTransactionRevenue.rejected,
      (state, action) => {
        state.distributionTransactionRevenueLoading = false;
        state.distributionTransactionRevenueError = action.payload;
        state.error = action.payload;
      }
    );

    // Forecast Revenue Plan
    builder.addCase(getForecastRevenuePlan.pending, (state) => {
      state.forecastRevenuePlanLoading = true;
      state.forecastRevenuePlanError = null;
      state.error = null;
    });
    builder.addCase(getForecastRevenuePlan.fulfilled, (state, action) => {
      state.forecastRevenuePlanLoading = false;
      state.balanceRawData = action.payload.plan_margin_dict;
    });
    builder.addCase(getForecastRevenuePlan.rejected, (state, action) => {
      state.forecastRevenuePlanLoading = false;
      state.forecastRevenuePlanError = action.payload;
      state.error = action.payload;
    });

    // Prospect Leads Reports
    builder.addCase(getProspectLeadsReports.pending, (state) => {
      state.prospectLeadsReportsLoading = true;
      state.prospectLeadsReportsError = null;
      state.error = null;
    });
    builder.addCase(getProspectLeadsReports.fulfilled, (state, action) => {
      state.prospectLeadsReportsLoading = false;
      state.verifiedSunRawData = action.payload.verified_sum;
      state.formFillSumRawData = action.payload.form_fill_sum;
    });
    builder.addCase(getProspectLeadsReports.rejected, (state, action) => {
      state.prospectLeadsReportsLoading = false;
      state.prospectLeadsReportsError = action.payload;
      state.error = action.payload;
    });

    // Prospect Leads Reports Detail
    builder.addCase(getProspectLeadsReportsDetail.pending, (state) => {
      state.prospectLeadsReportsDetailLoading = true;
      state.prospectLeadsReportsDetailError = null;
      state.error = null;
    });
    builder.addCase(
      getProspectLeadsReportsDetail.fulfilled,
      (state, action) => {
        state.prospectLeadsReportsDetailLoading = false;
        state.prospectleadDetailRawData = action.payload;
      }
    );
    builder.addCase(getProspectLeadsReportsDetail.rejected, (state, action) => {
      state.prospectLeadsReportsDetailLoading = false;
      state.prospectLeadsReportsDetailError = action.payload;
      state.error = action.payload;
    });

    // Gain Lost Accounts
    builder.addCase(getGainLostAccounts.pending, (state) => {
      state.gainLostAccountsLoading = true;
      state.gainLostAccountsError = null;
      state.error = null;
    });
    builder.addCase(getGainLostAccounts.fulfilled, (state, action) => {
      state.gainLostAccountsLoading = false;
      state.revinvData = { ...state.revinvData, ...action.payload.revinv_data };
      state.gainLost6RawData = action.payload.gl6m_dic;
      state.gainLost12RawData = action.payload.gl12m_dic;
      state.gainLost36RawData = action.payload.gl36m_dic;
    });
    builder.addCase(getGainLostAccounts.rejected, (state, action) => {
      state.gainLostAccountsLoading = false;
      state.gainLostAccountsError = action.payload;
      state.error = action.payload;
    });

    // Market By Customer
    builder.addCase(getMarketByCustomer.pending, (state) => {
      state.marketByCustomerLoading = true;
      state.marketByCustomerError = null;
      state.error = null;
    });
    builder.addCase(getMarketByCustomer.fulfilled, (state, action) => {
      state.marketByCustomerLoading = false;
      state.marketCustRawData = action.payload.market_customer;
    });
    builder.addCase(getMarketByCustomer.rejected, (state, action) => {
      state.marketByCustomerLoading = false;
      state.marketByCustomerError = action.payload;
      state.error = action.payload;
    });

    // Market Overview
    builder.addCase(getMarketOverview.pending, (state) => {
      state.getMarketOverviewLoading = true;
      state.getMarketOverviewError = null;
      state.error = null;
    });
    builder.addCase(getMarketOverview.fulfilled, (state, action) => {
      state.getMarketOverviewLoading = false;
      state.marketCustAllRawData = action.payload.market_overall;
    });
    builder.addCase(getMarketOverview.rejected, (state, action) => {
      state.getMarketOverviewLoading = false;
      state.getMarketOverviewError = action.payload;
      state.error = action.payload;
    });

    // Product By Revenue
    builder.addCase(getProductByRevenue.pending, (state) => {
      state.productByRevenueLoading = true;
      state.productByRevenueError = null;
      state.error = null;
    });
    builder.addCase(getProductByRevenue.fulfilled, (state, action) => {
      state.productByRevenueLoading = false;
      state.prrevRawData = action.payload.rev_pr_dic;
    });
    builder.addCase(getProductByRevenue.rejected, (state, action) => {
      state.productByRevenueLoading = false;
      state.productByRevenueError = action.payload;
      state.error = action.payload;
    });

    // Product By Customer Count
    builder.addCase(getProductByCustomerCount.pending, (state) => {
      state.productByCustomerCountLoading = true;
      state.productByCustomerCountError = null;
      state.error = null;
    });
    builder.addCase(getProductByCustomerCount.fulfilled, (state, action) => {
      state.productByCustomerCountLoading = false;
      state.prcustRawData = action.payload.cust_pr_dic;
    });
    builder.addCase(getProductByCustomerCount.rejected, (state, action) => {
      state.productByCustomerCountLoading = false;
      state.productByCustomerCountError = action.payload;
      state.error = action.payload;
    });

    // Rank By Stable Account
    builder.addCase(getRankByStableAccount.pending, (state) => {
      state.rankByStableAccountLoading = true;
      state.rankByStableAccountError = null;
      state.error = null;
    });
    builder.addCase(getRankByStableAccount.fulfilled, (state, action) => {
      state.rankByStableAccountLoading = false;
      state.salstbRawData = action.payload.stb_sal_rank;
    });
    builder.addCase(getRankByStableAccount.rejected, (state, action) => {
      state.rankByStableAccountLoading = false;
      state.rankByStableAccountError = action.payload;
      state.error = action.payload;
    });

    // Rank By Email
    builder.addCase(getRankByEmail.pending, (state) => {
      state.rankByEmailLoading = true;
      state.rankByEmailError = null;
      state.error = null;
    });
    builder.addCase(getRankByEmail.fulfilled, (state, action) => {
      state.rankByEmailLoading = false;
      state.salemRawData = action.payload.em_sal_rank;
    });
    builder.addCase(getRankByEmail.rejected, (state, action) => {
      state.rankByEmailLoading = false;
      state.rankByEmailError = action.payload;
      state.error = action.payload;
    });

    // Training Course
    builder.addCase(getTrainingCourse.pending, (state) => {
      state.trainingCourseLoading = true;
      state.trainingCourseError = null;
      state.error = null;
    });
    builder.addCase(getTrainingCourse.fulfilled, (state, action) => {
      state.trainingCourseLoading = false;
      state.trainingCourseRawData = action.payload;
      state.studentGradeItemsRawData = action.payload.student_course_grade_items;
    });
    builder.addCase(getTrainingCourse.rejected, (state, action) => {
      state.trainingCourseLoading = false;
      state.trainingCourseError = action.payload;
      state.error = action.payload;
    });

    // Training Module Summary
    builder.addCase(getTrainingModuleSummary.pending, (state) => {
      state.trainingModuleSummaryLoading = true;
      state.trainingModuleSummaryError = null;
      state.error = null;
    });
    builder.addCase(getTrainingModuleSummary.fulfilled, (state, action) => {
      state.trainingModuleSummaryLoading = false;
      state.trainingModuleSummaryRawData = action.payload;
    });
    builder.addCase(getTrainingModuleSummary.rejected, (state, action) => {
      state.trainingModuleSummaryLoading = false;
      state.trainingModuleSummaryError = action.payload;
      state.error = action.payload;
    });

    // Training Module
    builder.addCase(getTrainingModule.pending, (state) => {
      state.trainingModuleLoading = true;
      state.trainingModuleError = null;
      state.error = null;
    });
    builder.addCase(getTrainingModule.fulfilled, (state, action) => {
      state.trainingModuleLoading = false;
      state.trainingModuleRawData = action.payload;
    });
    builder.addCase(getTrainingModule.rejected, (state, action) => {
      state.trainingModuleLoading = false;
      state.trainingModuleError = action.payload;
      state.error = action.payload;
    });

    // Rank By Wgs Details
    builder.addCase(getRankByWgsDetails.pending, (state) => {
      state.rankByWgsDetailsLoading = true;
      state.rankByWgsDetailsError = null;
      state.error = null;
    });
    builder.addCase(getRankByWgsDetails.fulfilled, (state, action) => {
      state.rankByWgsDetailsLoading = false;
      state.rankByWgsDetailsRawData = action.payload;
    });
    builder.addCase(getRankByWgsDetails.rejected, (state, action) => {
      state.rankByWgsDetailsLoading = false;
      state.rankByWgsDetailsError = action.payload;
      state.error = action.payload;
    });

    // Product Analysis Detail
    builder.addCase(getProductAnalysisDetail.pending, (state) => {
      state.productAnalysisLoading = true;
      state.productAnalysisError = null;
      state.error = null;
    });
    builder.addCase(getProductAnalysisDetail.fulfilled, (state, action) => {
      state.productAnalysisLoading = false;
      state.prRawData = action.payload.pr_dic;
      state.ruleRawData = action.payload.rule_dic;
      state.cassRawData = action.payload.cass_dic;
    });
    builder.addCase(getProductAnalysisDetail.rejected, (state, action) => {
      state.productAnalysisLoading = false;
      state.productAnalysisError = action.payload;
      state.error = action.payload;
    });

    // Growth Rate Detail
    builder.addCase(getGrowthRateDetail.pending, (state) => {
      state.getGrowthRateDetailLoading = true;
      state.getGrowthRateDetailError = null;
      state.error = null;
    });
    builder.addCase(getGrowthRateDetail.fulfilled, (state, action) => {
      state.getGrowthRateDetailLoading = false;
      state.allRevinvData = action.payload.revinv_data;
    });
    builder.addCase(getGrowthRateDetail.rejected, (state, action) => {
      state.getGrowthRateDetailLoading = false;
      state.getGrowthRateDetailError = action.payload;
      state.error = action.payload;
    });

    // Client Salesmen Metrics
    builder.addCase(getClientSalesmenMetrics.pending, (state) => {
      state.clientSalesmenMetricsLoading = true;
      state.clientSalesmenMetricsError = null;
      state.error = null;
    });
    builder.addCase(getClientSalesmenMetrics.fulfilled, (state, action) => {
      state.clientSalesmenMetricsLoading = false;
      state.clientSalesmenData = action.payload;
    });
    builder.addCase(getClientSalesmenMetrics.rejected, (state, action) => {
      state.clientSalesmenMetricsLoading = false;
      state.clientSalesmenMetricsError = action.payload;
      state.error = action.payload;
    });

    // Rank By Retention
    builder.addCase(getRankByRetention.pending, (state) => {
      state.rankByRetentionLoading = true;
      state.rankByRetentionError = null;
      state.error = null;
    });
    builder.addCase(getRankByRetention.fulfilled, (state, action) => {
      state.rankByRetentionLoading = false;
      state.rankByRetentionData = action.payload.ret_sal_rank;
    });
    builder.addCase(getRankByRetention.rejected, (state, action) => {
      state.rankByRetentionLoading = false;
      state.rankByRetentionError = action.payload;
      state.error = action.payload;
    });

    // Branch Rank By Stable
    builder.addCase(getBranchRankByStable.pending, (state) => {
      state.branchRankByStableLoading = true;
      state.branchRankByStableError = null;
      state.error = null;
    });
    builder.addCase(getBranchRankByStable.fulfilled, (state, action) => {
      state.branchRankByStableLoading = false;
      state.branchRankByStableData = action.payload.stb_branch_rank;
    });
    builder.addCase(getBranchRankByStable.rejected, (state, action) => {
      state.branchRankByStableLoading = false;
      state.branchRankByStableError = action.payload;
      state.error = action.payload;
    });

    // Branch Rank By Email
    builder.addCase(getBranchRankByEmail.pending, (state) => {
      state.branchRankByEmailLoading = true;
      state.branchRankByEmailError = null;
      state.error = null;
    });
    builder.addCase(getBranchRankByEmail.fulfilled, (state, action) => {
      state.branchRankByEmailLoading = false;
      state.branchRankByEmailData = action.payload.email_branch_rank;
    });
    builder.addCase(getBranchRankByEmail.rejected, (state, action) => {
      state.branchRankByEmailLoading = false;
      state.branchRankByEmailError = action.payload;
      state.error = action.payload;
    });

    // Branch Rank By Retention
    builder.addCase(getBranchRankByRetention.pending, (state) => {
      state.branchRankByRetentionLoading = true;
      state.branchRankByRetentionError = null;
      state.error = null;
    });
    builder.addCase(getBranchRankByRetention.fulfilled, (state, action) => {
      state.branchRankByRetentionLoading = false;
      state.branchRankByRetentionData = action.payload.rt_branch_rank;
    });
    builder.addCase(getBranchRankByRetention.rejected, (state, action) => {
      state.branchRankByRetentionLoading = false;
      state.branchRankByRetentionError = action.payload;
      state.error = action.payload;
    });

    // get Associted Product
    builder.addCase(getAssociatedProduct.pending, (state) => {
      state.getAssociatedProductLoading = true;
      state.getAssociatedProductError = null;
      state.error = null;
    });
    builder.addCase(getAssociatedProduct.fulfilled, (state, action) => {
      state.getAssociatedProductLoading = false;
      state.associatedProductData = action.payload.associated_product;
    });
    builder.addCase(getAssociatedProduct.rejected, (state, action) => {
      state.getAssociatedProductLoading = false;
      state.getAssociatedProductError = action.payload;
      state.error = action.payload;
    });

  },
});


interface PortalManagementXState {
  saleLeadRawData?: any;
  error: any;
}

const initialStateX: PortalManagementXState = {
  saleLeadRawData: null,
  error: null,
};

export const PortalManagementXSlice = createSlice({
  name: "portalManagementX",
  initialState: initialStateX,
  reducers: {
    resetLastPurchase: (state) => {
      Object.assign(state, initialStateX);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => { return initialStateX; });

    builder.addCase(getLastPurchaseDetail.pending, (state) => {
      state.error = null;
    });
    builder.addCase(getLastPurchaseDetail.fulfilled, (state, action) => {
      state.saleLeadRawData = action.payload;
    });
    builder.addCase(getLastPurchaseDetail.rejected, (state, action) => {
      // Ignore superseded responses after a client switch.
      if ((action.payload as any)?.stale) return;
      state.error = action.payload;
    });
  },
});

export const { resetLastPurchase } = PortalManagementXSlice.actions;
export const portalManagementXReducer = PortalManagementXSlice.reducer;

export const {
  portalManagementReset,
  portalManagementSearchReset,

  recordRecentContext,
  setContextCommitted,
  setDefaultContext,
  updatePortalView,

  setSelectedClient,
  setSelectedProgram,
  setSelectedUserType,
  setSelectedSalesRep,
  setFilteredUserTypes,
  setSelectedBranch,
  setSelectedDepartment,
  setSelectedClientOther,
  setSelectedSchoolDealer

} = PortalManagementSlice.actions;

export const portalManagementReducer = PortalManagementSlice.reducer;
